import React, { Fragment, useState } from "react";
import {
  ArrowRepeat,
  ListOl,
  ListUl,
  Plus,
  Trash,
} from "react-bootstrap-icons";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { v4 as uuidv4 } from "uuid";
const uuid = uuidv4();
const BulletListGenerator = ({ openModal }) => {
  const [items, setItems] = useState(["", "", "", ""]);
  const [numbered, setNumbered] = useState(false);
  const [bulletColor, setBulletColor] = useState("#fb923c"); // Tailwind blue-600 default
  // State for chosen text color
  const [textColor, setTextColor] = useState("#000000"); // Tailwind gray-900

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      items,
      numbered,
      bulletColor,
      textColor,
    };
    const result = `<div id="${uuid}" /><p><BulletList items={${JSON.stringify(
      data.items
    )}} numbered={${JSON.stringify(data.numbered)}} bulletColor="${
      data.bulletColor
    }"  /></p>`;
    openModal(result);
  };

  const handleItemChange = (index, value) => {
    const updatedItems = [...items];
    updatedItems[index] = value;
    setItems(updatedItems);
  };

  /* const handleOptionChange = (value) => {
    const index = choices.findIndex((item) => {
      return item === value;
    });
    setSelected(value);
    setAnswerIndex(index);
    // const option = event.target.value;
    //const optionIndex = event.target.selectedIndex;
    //setSelectedOption(option);
  };*/
  const addItem = () => {
    setItems([...items, ""]);
    console.log(items);
  };
  const deleteItem = (id) => {
    if (items.length >= 3) {
      setItems([...items.slice(0, id), ...items.slice(id + 1)]);
    } else {
    }
  };
  return (
    <>
      <div className="grid  m-auto p-2">
        <form>
          <div className="flex flex-col gap-6 ">
            <div className="my-2 ">
              <label
                className="text-sm block text-gray-700 font-bold mb-2"
                htmlFor="Choices"
              >
                Items
              </label>
              {items.map((item, index) => (
                <div className="mb-4">
                  <label
                    //className="flex w-full h-full select-none pointer-events-none absolute left-0 font-normal !overflow-visible truncate peer-placeholder-shown:text-blue-gray-500 leading-tight peer-focus:leading-tight peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500 transition-all -top-1.5 peer-placeholder-shown:text-sm text-[11px] peer-focus:text-[11px] before:content[' '] before:block before:box-border before:w-2.5 before:h-1.5 before:mt-[6.5px] before:mr-1 peer-placeholder-shown:before:border-transparent before:rounded-tl-md before:border-t peer-focus:before:border-t-2 before:border-l peer-focus:before:border-l-2 before:pointer-events-none before:transition-all peer-disabled:before:border-transparent after:content[' '] after:block after:flex-grow after:box-border after:w-2.5 after:h-1.5 after:mt-[6.5px] after:ml-1 peer-placeholder-shown:after:border-transparent after:rounded-tr-md after:border-t peer-focus:after:border-t-2 after:border-r peer-focus:after:border-r-2 after:pointer-events-none after:transition-all peer-disabled:after:border-transparent peer-placeholder-shown:leading-[3.75] text-blue-gray-400 peer-focus:text-blue-500 before:border-blue-gray-200 peer-focus:before:!border-blue-500 after:border-blue-gray-200 peer-focus:after:!border-blue-500">
                    className="text-xs block text-gray-400 font-bold mb-2"
                  >
                    {"Item " + index}
                  </label>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      key={index}
                      value={item}
                      onChange={(e) => handleItemChange(index, e.target.value)}
                      className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      placeholder=" "
                    />
                    <button type="reset" onClick={() => deleteItem(index)}>
                      <Trash className="text-red-500" size={20} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex items-center space-x-6">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  className="form-radio text-blue-500"
                  name="listType"
                  checked={numbered === false}
                  onChange={() => setNumbered(false)}
                />
                <span className="ml-2">
                  <ListUl size={40} />
                </span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  className="form-radio text-blue-500"
                  name="listType"
                  checked={numbered === true}
                  onChange={() => setNumbered(true)}
                />
                <span className="ml-2">
                  <ListOl size={40} />
                </span>
              </label>
              <label className="inline-flex items-center">
                <span className="mr-2">Bullet Color:</span>
                <input
                  type="color"
                  value={bulletColor}
                  onChange={(e) => setBulletColor(e.target.value)}
                  className="w-6 h-6 border-0 p-0"
                />
              </label>
              {/**   <label className="inline-flex items-center">
                <span className="mr-2">Text Color:</span>
                <input
                  type="color"
                  value={textColor}
                  onChange={(e) => setTextColor(e.target.value)}
                  className="w-6 h-6 border-0 p-0"
                />
              </label>*/}
            </div>
            <button
              className=" btn btn-circle  m-auto "
              onClick={addItem}
              type="reset"
            >
              <Plus size={30} />
            </button>

            <div className="flex flex-row m-auto mt-4">
              <button
                onClick={handleSubmit}
                id="submitButton"
                key="submitButton"
                type="submit"
                className=" btn    m-auto mx-4  "
              >
                Create Bullet List
              </button>
              <button
                id="resetButton"
                key="resetButton"
                type="reset"
                onClick={() => {
                  setItems(["", "", "", ""]);
                }}
                className=" btn btn-circle   m-auto  "
              >
                <ArrowRepeat size={30} />
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default BulletListGenerator;
